; function CommentsLsAjaxHTML() {
    const DOMDisplay = CommentsLsDOMDisplay();

    const HTTP_METHOD = {
        GET: "get",
        POST: "post",
    };
    const REQUEST_STATUS = {
        SUCCESS: "success",
        ERROR: "error",
    };
    const URL = {
        GET_FORM_ANSWER: '/comment-ls/get-html-form-answer',
        GET_FORM_UPDATE: '/comment-ls/get-html-form-update',
        GET_COMMENT: '/comment-ls/get-comment-by-id',
    }

    const content = document.querySelector("form.comment-form-create");
    let content_id = 0;
    if (content) {
        content_id = content.getAttribute("data-content_id");
    }

    return {
        insertFormAnswer(target, appendInElement, withId) {
            const urlWithData = URL.GET_FORM_ANSWER + `?id=${withId}&content_id=${content_id}`;
            $.ajax({url: urlWithData, type: HTTP_METHOD.GET, dataType: "json"}).done((request) => {
                if (request.status === REQUEST_STATUS.SUCCESS) {
                    DOMDisplay.hide(target);
                    appendInElement.append(request.view);
                }
            });
        },

        insertFormUpdate(inElement, withId, withMessage) {
            const urlWithData = URL.GET_FORM_UPDATE + `?id=${withId}&message=${withMessage}&content_id=${content_id}`;
            $.ajax({url: urlWithData, type: HTTP_METHOD.GET, dataType: "json"}).done((request) => {
                if (request.status === REQUEST_STATUS.SUCCESS) {
                    const commentHeight = inElement.height();

                    inElement.html(request.view);

                    const textarea = inElement.find("textarea"),
                        buttonContainer = inElement.find(".comment-buttons-mini"),
                        heightForTextArea = (commentHeight - buttonContainer.height());

                    textarea.css("height", heightForTextArea + "px");
                }
            });
        },

        insertComment(replaceElement, byId) {
            const urlWithData = URL.GET_COMMENT + "?id=" + byId;
            $.ajax({url: urlWithData, type: HTTP_METHOD.GET, dataType: "json"}).done((request) => {
                if (request.status === REQUEST_STATUS.SUCCESS) {
                    replaceElement.replaceWith(request.view);
                }
            });
        }
    }
}
